import React, { useEffect, useState } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";
import { toast } from "sonner";
import { Envelope } from "@phosphor-icons/react";

const PLACEHOLDERS = ["{name}", "{email}", "{reference}", "{amount}", "{link}"];

export default function AdminTemplates() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [draft, setDraft] = useState({ subject: "", body: "" });

  const load = async () => { const { data } = await api.get("/templates"); setItems(data.items); };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const open = (t) => { setSelected(t); setDraft({ subject: t.subject, body: t.body }); };
  const save = async () => {
    if (!selected) return;
    await api.patch(`/templates/${selected.template_id}`, draft);
    toast.success("Template saved");
    load();
  };

  return (
    <div className="App min-h-screen">
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-10">
        <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-2">Communications</div>
        <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl mb-8">Email templates.</h1>

        <div className="grid md:grid-cols-3 gap-6">
          <div className="border border-border bg-white">
            <div className="p-3 border-b border-border font-semibold text-sm">Templates</div>
            <div className="divide-y divide-border">
              {items.map((t) => (
                <button
                  key={t.template_id}
                  data-testid={`tpl-${t.kind}`}
                  onClick={() => open(t)}
                  className={`w-full text-left p-3 hover:bg-muted flex items-center gap-2 ${selected?.template_id === t.template_id ? "bg-muted" : ""}`}
                >
                  <Envelope size={14} className="text-muted-foreground" />
                  <div className="min-w-0">
                    <div className="text-sm font-medium">{t.kind}</div>
                    <div className="text-[11px] text-muted-foreground truncate">{t.subject}</div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          <div className="md:col-span-2 border border-border bg-white p-6 min-h-[400px]">
            {!selected && <div className="grid place-items-center h-full text-sm text-muted-foreground">Select a template to edit.</div>}
            {selected && (
              <div className="space-y-3">
                <div className="text-xs font-mono uppercase tracking-widest-2 text-muted-foreground">Kind: {selected.kind}</div>
                <div><Label>Subject</Label><Input data-testid="tpl-subject" value={draft.subject} onChange={(e) => setDraft({ ...draft, subject: e.target.value })} className="mt-1" /></div>
                <div><Label>Body</Label><Textarea data-testid="tpl-body" rows={10} value={draft.body} onChange={(e) => setDraft({ ...draft, body: e.target.value })} className="mt-1" /></div>
                <div className="text-xs text-muted-foreground">
                  Placeholders: {PLACEHOLDERS.map((p) => <code key={p} className="mx-1 px-1 bg-muted">{p}</code>)}
                </div>
                <Button data-testid="tpl-save" onClick={save} className="rounded-sm">Save template</Button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
